import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function LoginAdmin({ isAdmin, setIsAdmin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (isAdmin) {
      navigate('/admin');
    }
  }, [isAdmin, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch('/api/login.php', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    })
      .then(res => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(() => {
        setIsAdmin(true);
        navigate('/admin');
      })
      .catch(() => {
        setError('Identifiants incorrects');
      });
  };

  return (
    <main className="page-container bg-custom">
      <div className='container text-center' style={{maxWidth: '500px'}}>
        <h1 className='page-title'>LOGIN ADMIN</h1>  

        {error && <div className="alert alert-danger">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            className="form-control mb-3"
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />

          <input
            className="form-control mb-3"
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />

          <button className="btn btn-primary w-100">
            Se connecter
          </button>
        </form>
      </div>
    </main>
  );
}